import {
  format
} from 'date-fns';

import calendaryActivityTypes from 'constants/calendar-activity-types';

function buildAssigneesForDisplay(assigneeIds, usersMap) {

  const assignees = [];

  for (let assigneeId of assigneeIds) {

    assignees.push({
      ...usersMap[assigneeId]
    });

  }

  return assignees;

}

function buildAttendeesForDisplay(attendees, usersMap) {

  const attendeesForDisplay = [];

  for (let attendee of attendees) {

    attendeesForDisplay.push({
      ...attendee,
      ...usersMap[attendee.startupUserId]
    });

  }

  return attendeesForDisplay;

}

function formatActivityEventSchedule(event) {

  const startDate = new Date(event.startDateTime);
  const endDate = new Date(event.endDateTime);

  event.startDate = format(startDate, 'yyyy-MM-dd');
  event.startTime = format(startDate, 'HH:mm');
  event.endDate = format(endDate, 'yyyy-MM-dd');
  event.endTime = format(endDate, 'HH:mm');

}

export function buildActivityForDisplay(result) {

  const activity = result.activity;
  const event = result.event;
  const usersMap = result.usersMap;

  activity.event = event;

  formatActivityEventSchedule(activity.event);

  activity.event.creator = result.usersMap[activity.event.creatorId];

  if (activity.type === calendaryActivityTypes.TASK) {
    activity.event.assignees = buildAssigneesForDisplay(event.assigneeIds, usersMap);
  } else {
    activity.event.attendees = buildAttendeesForDisplay(event.attendees, usersMap);
  }

  activity.event.reminders = activity.reminders;

  return activity;

}